<form class="contact-form" nz-form [formGroup]="contactForm" (ngSubmit)="contact()">
    <h3 class="text-center" style="margin-bottom: 40px;">
        {{"what are you thinking about? Message us now!!" | translate}}
    </h3>
    <div class="row">
        <div class="col-md-4">
            <div class="input-group-lg">
                <nz-form-item class="contact-form-item">
                    <nz-form-control nzErrorTip="بالرجاء كتابة الاسم">
                        <nz-input-group nzPrefixIcon="user">
                            <input  
                            class="form-control" 
                            nz-input 
                            formControlName="name" 
                            placeholder="الاسم" />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div class="col-md-4">
            <div class="input-group-lg">
                <nz-form-item class="contact-form-item">
                    <nz-form-control nzErrorTip="بالرجاء كتابة البريد الالكتروني">
                        <nz-input-group nzPrefixIcon="mail">
                            <input
                                placeholder="البريد الالكتروني"
                                nz-input
                                [(ngModel)]="inputValue"
                                (input)="onInput($event)"
                                [nzAutocomplete]="auto"
                                type="email"
                                formControlName="email"
                                class="form-control" />
                            <nz-autocomplete #auto>
                                <nz-auto-option *ngFor="let option of options" [nzValue]="option">{{ option }}</nz-auto-option>
                            </nz-autocomplete>  
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div> 
        
        <div class="col-md-4">
            <div class="input-group-lg">
                <nz-form-item class="contact-form-item">
                    <nz-form-control nzErrorTip="بالرجاء كتابة عنوان الرسالة">
                        <nz-input-group nzPrefixIcon="edit">
                            <input  
                            class="form-control" 
                            nz-input 
                            formControlName="title" 
                            placeholder="عنوان الرسالة" />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        
        <div class="col-md-12">
            <div class="input-group-lg">
                <nz-form-item class="contact-form-item">
                    <nz-form-control nzErrorTip="بالرجاء كتابة الرسالة">
                        <textarea
                            nz-input
                            placeholder="الرسالة"
                            [nzAutosize]="{ minRows: 6, maxRows: 10 }"
                            formControlName="message"></textarea>   
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div> 
        
        <div class="col-md-2 text-center">
            <div class="input-group-lg">
                <nz-form-item>
                    <nz-form-control>
                        <button
                            class="form-control btn"
                            [disabled]="!contactForm.valid"
                            nz-button 
                            matRipple>
                            <div class="loader text-center w-100" *ngIf="loader">
                                <nz-spin nzSimple></nz-spin>
                            </div>                                        
                            <span *ngIf="!loader">
                                راسلنا الان!!
                            </span>
                        </button>
                    </nz-form-control>
                </nz-form-item>                    
            </div>
        </div>         
    </div>
</form>